"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _map = require("rxjs/operators/map");

var _AdsActions = require("../actions/AdsActions");

var _NotificationActions = require("ReduxMessenger/actions/NotificationActions");

var oauthErrorNotificationEpic = function oauthErrorNotificationEpic($action) {
  return $action.ofType(_AdsActions.AdsActionTypes.SHOW_OAUTH_ERROR_NOTIFICATION).pipe((0, _map.map)(function (action) {
    var payload = action.payload;
    return (0, _NotificationActions.postNotification)((0, _extends2.default)({
      id: 'OAUTH_ERROR_NOTIFICATION',
      type: 'danger',
      titleText: payload.title,
      message: payload.body
    }, payload.opts));
  }));
};

var _default = oauthErrorNotificationEpic;
exports.default = _default;
module.exports = exports.default;